(function () {

  function initToc() {

    const article = document.getElementById('mainArticle');
    const navList = document.getElementById('navList');

    if (!article || !navList) return;

    const headings = article.querySelectorAll(
      'h2.seo-left-desktop-center-mobile'
    );

    if (!headings.length) return;

    headings.forEach((heading, index) => {

      // 自动生成ID
      if (!heading.id) {

        let rawText = heading.innerText.trim();

        let slug = rawText
          .toLowerCase()
          .replace(/[^\w\u4e00-\u9fa5]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');

        heading.id = slug || `section-${index}`;
      }

      // 创建目录项
      const li = document.createElement('li');
      const a = document.createElement('a');

      a.className = 'nav-link';
      a.textContent = heading.innerText;
      a.href = `#${heading.id}`;

      // 点击平滑滚动
      a.addEventListener('click', (e) => {

        e.preventDefault();

        document
          .getElementById(heading.id)
          ?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

      });

      li.appendChild(a);
      navList.appendChild(li);

    });

    // ==========================
    // Scroll Active Highlight
    // ==========================

    const navLinks = navList.querySelectorAll('.nav-link');

    const observer = new IntersectionObserver(

      (entries) => {

        entries.forEach(entry => {

          if (!entry.isIntersecting) return;

          const id = entry.target.id;

          navLinks.forEach(link => {
            link.classList.remove('active');
          });

          const currentLink = navList.querySelector(
            `a[href="#${id}"]`
          );

          currentLink?.classList.add('active');

        });

      },

      {
        root: null,

        // 当前标题进入视口上半部分时激活
        rootMargin: '-20% 0px -70% 0px',

        threshold: 0
      }

    );

    headings.forEach(heading => {
      observer.observe(heading);
    });

    // 默认激活第一个
    if (navLinks.length) {
      navLinks[0].classList.add('active');
    }

  }

  document.addEventListener(
    'DOMContentLoaded',
    initToc
  );

})();